module.exports = new __parcel__URL__("pvp_defeat_icon.c38873e8.png").toString();